<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Set the participant's
      <span :class="{'has-error':errors.studyVariableId}">
        <select :value="studyVariableId" name="studyVariableId" class="form-control" @change="handleChange">
          <option value="">Select Variable</option>
          <option v-for="variable in dateVariables" :value="variable.id">{{ variable.name }}</option>
        </select>
      </span>
      variable value
      <span :class="{'has-error':errors.modification}">
        to
        <select v-model="modification" class="form-control">
          <option disabled :value="{}">Select Option</option>
          <option :value="{modificationType: 'today'}">Today's date</option>
          <optgroup label="A date variable">
            <option
              v-for="variable in dateVariables"
              :value="{modificationType: 'variable', secondaryVariableId: variable.id}"
            >
              {{ variable.name }}
            </option>
          </optgroup>
          <optgroup v-if="webhookVariables" label="A webhook variable">
            <option
                v-for="variable in webhookVariables"
                :value="{modificationType: 'variable', secondaryVariableId: variable.id}"
            >
              {{ variable.name }}
            </option>
          </optgroup>
          <optgroup v-if="eventFields.length" label="Data from this event">
            <option
              v-for="field in eventFields"
              :value="{modificationType: 'event', exportTag: field.tag}"
            >
              {{ field.tag }}
            </option>
          </optgroup>
        </select>
      </span>
      <select :value="offsetType" name="offsetType" class="form-control" @change="handleChange">
        <option />
        <option>plus</option>
        <option>minus</option>
      </select>
      <select v-if="!!offsetType" v-model="modificationOperation" class="form-control">
        <option disabled :value="{}">Select Option</option>
        <option :value="{modificationOperationType: 'integer'}">An integer</option>
        <optgroup v-if="pointBalanceVariables" label="A point balance variable">
          <option
            v-for="variable in pointBalanceVariables"
            :value="{modificationOperationType: 'variable', operationVariableId: variable.id}"
          >
            {{ variable.name }}
          </option>
        </optgroup>
      </select>
      <span v-if="!!offsetType && modificationOperationType === 'integer'" :class="{'has-error':errors.offset}">
        <input
          :value="offset"
          class="form-control input-numeric"
          name="offset"
          type="number"
          step="1"
          min="0"
          @input="handleChange"
        > days
      </span>
    </div>
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import { enumValidator } from "@/EventLogic/util";

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      studyVariableId: {
        // the variable whose value will be changed
        // Fundamentally a number, but often stored as a string
        type: [Number, String]
      },
      secondaryVariableId: {
        // the variable whose value will be pulled for the (basis of) the new value
        // Fundamentally a number, but often stored as a string
        type: [Number, String]
      },
      operationVariableId: {
        // the variable whose value will be pulled for the (basis of) the new value
        // Fundamentally a number, but often stored as a string
        type: [Number, String]
      },
      exportTag: {
        // the aFormField whose value will be pulled for the (basis of) the new value
        type: String
      },
      modificationType: {
        type: String,
        default: null,
        validator: enumValidator(['today', 'variable', 'event'])
      },
      offsetType: {
        type: String,
        default: '',
        validator: enumValidator(['plus', 'minus', ''])
      },
      modificationOperationType: {
        type: String,
        default: null,
        validator: enumValidator(['integer', 'variable'])
      },
      offset: {
        type: String
      },
    },
    data() {
      const modification = {
        modificationType: this.modificationType,
        secondaryVariableId: this.secondaryVariableId,
        exportTag: this.exportTag,
      };

      for (const propName in modification) {
        if (!modification[propName]) {
          delete modification[propName];
        }
      }

      const modificationOperation = {
        modificationOperationType: this.modificationOperationType,
      }

      if (this.operationVariableId) {
        modificationOperation.operationVariableId = this.operationVariableId;
      }


      return {
        modification,
        modificationOperation
      };
    },
    computed: {
      dateVariables: function () {
        if (this.config.studyVariablesByType['DateVariable']) {
          return this.config.studyVariablesByType['DateVariable'];
        }
        return {};
      },
      webhookVariables: function () {
        let variables = {};
        if (this.config.studyVariablesByType['WebhookVariable']) {
          return this.config.studyVariablesByType['WebhookVariable'];
        }
        return {};
      },
      pointBalanceVariables: function () {
        let variables = {};
        if (this.config.studyVariablesByType['PointBalanceVariable']) {
          return this.config.studyVariablesByType['PointBalanceVariable'];
        }
        return {};
      },
      eventFields() {
        return Object.entries(this.config.sourceFields)
          .map(function ([id, obj]) {
            return {...obj, id};
          })
          .filter(obj => obj.type === 'date');
      },
    },
    watch: {
      modification() {
        this.$emit('update:modificationType', this.modification.modificationType);
        this.$emit('update:secondaryVariableId', this.modification.secondaryVariableId);
        this.$emit('update:exportTag', this.modification.exportTag);
      },
      modificationOperation() {
        this.$emit('update:modificationOperationType', this.modificationOperation.modificationOperationType);
        this.$emit('update:operationVariableId', this.modificationOperation.operationVariableId);
      }
    },
    methods: {
      validate: function () {
        this.errors = {};

        if (!this.isNumber(this.studyVariableId)) {
          this.errors.studyVariableId = "Please select a Variable to modify.";
        }

        if (!this.modificationType) {
          this.errors.offset = 'Please select how the variable should be updated';
        }

        if (this.offsetType && this.modificationOperationType === 'integer' && this.offset.length === 0) {
          this.errors.offset = 'Please select how many days to add or subtract';
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
